import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
import InputStyles from "../InputStyles";
import { generateRandomString } from "../../../utils/helpers";

// https://developer.salesforce.com/docs/marketing/marketing-cloud/guide/using_regular_expressions_to_validate_email_addresses.html
const emailRegex =
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

const EmailInput = ({
  register,
  fieldName,
  label,
  required,
  formState: { errors = {} } = {},
  placeholder,
  helperText,
}) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  const inputRandomId = isClient
    ? `${fieldName}-${generateRandomString()}`
    : null;

  return (
    <InputStyles className="email-input">
      <div className="label-container">
        <div>
          <label
            htmlFor={inputRandomId}
            dangerouslySetInnerHTML={{ __html: label }}
          />
          {required && <span className="required-asterisk">*</span>}
        </div>
        {helperText && <span className="helper-text">{helperText}</span>}
      </div>
      <input
        id={inputRandomId}
        className={`${errors[fieldName] ? "error" : ""}`}
        {...register(fieldName, {
          required: required ? `${label} is required` : false,
          pattern: {
            value: emailRegex,
            message: "Please enter a valid email address",
          },
        })}
        placeholder={placeholder}
      />
      {errors[fieldName] && (
        <span className="input-error">{errors[fieldName].message}</span>
      )}
    </InputStyles>
  );
};
export default EmailInput;

// EmailInput.propTypes = {
//   register: PropTypes.func.isRequired,
//   fieldName: PropTypes.string.isRequired,
//   label: PropTypes.string.isRequired,
//   required: PropTypes.bool,
//   formState: PropTypes.object,
//   placeholder: PropTypes.string,
//   errorMessage: PropTypes.string,
//   helperText: PropTypes.string,
// };
